<template>
  <img
    :style="color ? `filter:${filterColor}` : ''"
    :width="size"
    :class="{spinner: spin}"
    :src="`/icons/${path}.svg`"
    :alt="alt"
    :aria-hidden="alt ? undefined : 'true'"
  >
</template>

<script setup lang="ts">
import { generateFilter } from 'colorize-filter'

const props = withDefaults(
  defineProps<{
    path?: string,
    color?: string,
    size?: string
    spin?: boolean
    /** 의미를 가진 아이콘일 때만 지정. 비워두면 장식용으로 간주해 스크린리더에서 숨김 */
    alt?: string
  }>(),
  {
    path: '',
    color: '', // #000000 default
    size: '20',
    spin: false,
    alt: ''
  }
)

const filterColor = computed(() => props.color ? generateFilter(props.color) : 'filter: brightness(0) saturate(100%) invert(0%) sepia(6%) saturate(7478%) hue-rotate(263deg) brightness(89%) contrast(104%);')
</script>


<style scoped lang="scss">
.spinner {
  animation: spinner 1s linear infinite;
}
@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
